import { LearningProgress } from '../types';

const STORAGE_KEY = 'zynex_ninja_learning_progress_v1';

const defaultProgress: LearningProgress = {
  completedLessonIds: [],
  currentLessonId: 'lesson-1-1',
  comprehensionAnswers: {},
  updatedAt: new Date().toISOString(),
};

export class LearningStorageService {
  static getProgress(): LearningProgress {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return defaultProgress;
      const parsed = JSON.parse(raw);
      return {
        ...defaultProgress,
        ...parsed,
      };
    } catch {
      return defaultProgress;
    }
  }

  static saveProgress(progress: LearningProgress): void {
    try {
      const updated = {
        ...progress,
        updatedAt: new Date().toISOString(),
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch (err) {
      console.error('Failed to save learning progress:', err);
    }
  }

  static markLessonComplete(lessonId: string, answerValue?: string): LearningProgress {
    const current = this.getProgress();
    const completedSet = new Set(current.completedLessonIds);
    completedSet.add(lessonId);

    const updatedAnswers = { ...current.comprehensionAnswers };
    if (answerValue) {
      updatedAnswers[lessonId] = answerValue;
    }

    const updated: LearningProgress = {
      ...current,
      completedLessonIds: Array.from(completedSet),
      currentLessonId: lessonId,
      comprehensionAnswers: updatedAnswers,
    };

    this.saveProgress(updated);
    return updated;
  }
}
